let lookup = null;

//The market a landing sells to - declared on <html data-phone-country>,
//else inferred from the domain / page language. Only a fallback now that the
//checkout asks for the delivery country; see deliveryCountry below.
export function marketCountry() {
	const declared = document.documentElement.getAttribute("data-phone-country");
	if (declared) {
		return declared.toUpperCase();
	}
	if (window.location.hostname.slice(-3) === ".in") {
		return "IN";
	}
	if (document.documentElement.lang === "el") {
		return "GR";
	}
	return "GB";
}

//Where the parcel goes, read from the checkout's country field and scoped to
//the form the given element belongs to, since a landing may repeat the whole
//checkout on one page. This is what the delivery-side features follow - the
//visitor's own location says nothing about the address they are typing.
export function deliveryCountry(element) {
	const form = element && element.closest ? element.closest("form") : null;
	const field =
		(form && form.querySelector('[name="country"]')) ||
		document.querySelector('[name="country"]');
	const declared = field && field.value ? field.value.trim().toUpperCase() : "";

	return declared || marketCountry();
}

export function visitorCountry() {
	if (!lookup) {
		lookup = fetch(
			"https://pro.ip-api.com/json/?fields=8437971&key=7oWVQhtdey15tpZ",
		)
			.then((response) => response.json())
			.then((data) =>
				data.status === "success" && data.countryCode
					? data.countryCode
					: marketCountry(),
			)
			.catch(() => marketCountry());
	}
	return lookup;
}

export function fillCountryFields() {
	const fields = document.querySelectorAll(
		'input[name="country"], select[name="country"], select[name="country_code"]',
	);

	if (!fields.length) {
		return;
	}

	visitorCountry().then((countryCode) => {
		fields.forEach((field) => {
			if (field.value) {
				return;
			}
			if (field.tagName === "SELECT") {
				const option = Array.from(field.options).find(
					(o) => o.value.toUpperCase() === countryCode,
				);
				if (option) {
					field.value = option.value;
				}
			} else {
				field.value = countryCode;
			}
		});
	});
}
